import Decimal from 'decimal.js';
export var TEN = new Decimal(10);
export var ZERO = new Decimal(0);
export var NEGATIVE_ZERO = new Decimal(-0);
